import * as React from 'react'
import Loader from './Loader'
import { AuthContext } from '../../../context/authContext'
import { IDENTITY_SIGNIN_REDIRECT_DEFAULT_STATE_VALUES } from 'utils/constants'
import { IFTTT } from '../../../utils/misc'
import { useLocation } from 'react-router-dom'

const Auth = () => {
  const { authService } = React.useContext(AuthContext)
  const { isAuthenticated, signinRedirect } = authService
  const location = useLocation()
  IFTTT(isAuthenticated, () => signinRedirect(location?.state ?? IDENTITY_SIGNIN_REDIRECT_DEFAULT_STATE_VALUES))
  return <Loader />
}

export default Auth
